import { render, staticRenderFns } from "./cBarChart.vue?vue&type=template&id=08f4131b&scoped=true"
import script from "./cBarChart.vue?vue&type=script&lang=js"
export * from "./cBarChart.vue?vue&type=script&lang=js"
import style0 from "./cBarChart.vue?vue&type=style&index=0&id=08f4131b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f4131b",
  null
  
)

export default component.exports